module.exports = __webpack_public_path__ + "static/area-with-negative-values-3fb768f62c95cee3fe58836c2c3b2fca.png";